import * as React from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { useDropzone, FileWithPath } from 'react-dropzone';
import { NavLink } from 'react-router-dom';
import { formatBytes } from '../../Hooks/bytesToMB';
import useClickOutside from '../../Hooks/useClickOutside';
import { AnimatePresence, motion } from "framer-motion"

import './CreateNFT.scss';
import { Previews } from './CreateNFTPreviews';
import { collectionsData } from '../../Shared/GlobalDataFactory';
export interface ICreateNFTProps {
}

export function CreateNFT(props: ICreateNFTProps) {
    // 1st Drag and drop functionality------------------


    const [previewThumb, setPreviewThumb] = useState<any>(null)
    const {
        acceptedFiles,
        fileRejections,
        getRootProps,
        getInputProps,
        isDragActive
    } = useDropzone({
        // accept: 'image/gif,image/png,image/webp,image/svg,image/webm,image/wav,image/ogg,image/glb,image/gltf,video/mp4,audio/mp3',
        accept: ["image/*", "video/mp4", "audio/*"],
        maxSize: 100000000,
        multiple: false,
        onDrop: acceptedFiles => {
            const acceptedFileWithPreviewSrc = acceptedFiles.map(file => {
                // const previewThumbSrc = Object.assign(file, { preview: URL.createObjectURL(file) })
                const fileType = file.type.split('/')[0]
                setPreviewThumb({
                    src: URL.createObjectURL(file),
                    type: fileType
                })
            })
        }
    });

    const files = acceptedFiles.map((file: FileWithPath) => (
        <span
            className="text-cusBlueWhite"
            key={file.path}>
            {file.path} - {formatBytes(file.size)}
        </span>
    ));









    // hanlde collection select option
    const [colleSelectOpen, setColleSelectOpen] = useState(false);
    const [collectionSelectedData, setCollectionSelectedData] = useState<any>(null)
    const collectionSelectRef = React.useRef<HTMLHeadingElement>(null);
    useClickOutside(collectionSelectRef, () => setColleSelectOpen(false))

    // Sale type-------------
    const [saleTypeDropOpen, setSaleTypeDropOpen] = React.useState(false);
    const [saleTypeDropText, setSaleTypeDropText] = React.useState<any>('Select...')
    const saleTypeRef = React.useRef<HTMLHeadingElement>(null);
    useClickOutside(saleTypeRef, () => setSaleTypeDropOpen(false))







    const handleCreateItemFormSubmit = (e: any) => {
        e.preventDefault()
    }

    return (
        <div className="text-left mx-auto create_nft_main_box my-32
        px-[20px]
        sm:max-w-[480px]
        md:max-w-[540px]
        lg:max-w-[740px]
        xl:max-w-[908px]
        2xl:max-w-[1024px]
        ">
            <h1 className="xs:text-2xl xl:text-3xl font-bold text-cusBlack dark:text-white">Create New Item</h1>

            <form action="" onSubmit={handleCreateItemFormSubmit}>
                <div className="lg:flex-row xs:flex-col flex justify-between items-start mt-5 ">





                    <div className="flex-1 xs:order-2 lg:order-1">
                        <div className="">
                            <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-lg">Upload Image, Video, Audio, or 3D Model <span className="text-cusLink">*</span></h4>

                            <div {...getRootProps({ className: 'mt-3' })}>
                                <input {...getInputProps()} />
                                <div className={`${isDragActive
                                    ? 'bg-blue-100 dark:bg-blue-900 border-dashed border-2 border-blue-500 dark:border-blue-600 scale-105'
                                    : 'bg-[#ffffff] dark:bg-[#0E0631] border-dashed border-[#D8D8D8] dark:border-[#3d3892]'}
                                    transition-all duration-500 border-2 rounded-xl hover:border-blue-500 dark:hover:border-blue-600
                                    h-52 flex justify-center items-center px-6
                                    `}>
                                    <div className="text-center">
                                        {files.length !== 0
                                            ? <p className="text-white xs:text-xxs sm:text-base">Your File: {files}</p>
                                            : fileRejections.length !== 0
                                                ? <p className="text-red-500 dark:text-red-400 xs:text-xxs sm:text-base">{fileRejections[0]?.errors[0]?.message}</p>
                                                : <p className="text-l-LightBlack dark:text-cusBlueWhite xs:text-xxs sm:text-base">File types supported: JPG, PNG, GIF, SVG, MP4, WEBM, MP3, WAV, OGG, GLB, GLTF. Max size: 100 MB</p>
                                        }
                                        <button
                                            className="font-semibold dark:font-medium bg-cusBrightLink dark:bg-black mt-4 text-cusLightLink dark:text-cusLink xs:px-4 sm:px-6 xs:py-1 sm:py-3 rounded-full xs:text-xs sm:text-base">
                                            Choose file
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="mt-8">
                            <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Name <span className="text-cusLink">*</span></h4>
                            <input type="text" name="" id="" placeholder='e. g. "Redeemable T-Shirt with logo"'
                                className="w-full h-full  text-cusBlack dark:text-white
                                    outline-none lightBlueBg p-4 sm:p-6 rounded-xl mt-3 duration-300 form-input transition-all" />
                        </div>

                        <div className="mt-8">
                            <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">External link</h4>
                            <p className="xs:text-xxs mt-2 sm:text-sm text-cusBlack dark:text-cusBlueWhite">UNC will include a link to this URL on this item's detail page, so that users can click to learn more about it. You are welcome to link to your own webpage with more details.</p>
                            <input type="text" name="" id="" placeholder='https://yoursite.io/item/12'
                                className="w-full h-full  text-cusBlack dark:text-white
                                    outline-none lightBlueBg p-4 sm:p-6 rounded-xl mt-3 duration-300 form-input transition-all" />
                        </div>

                        <div className="mt-8">
                            <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Description</h4>
                            <p className="xs:text-xxs mt-2 sm:text-sm text-cusBlack dark:text-cusBlueWhite">The description will be included on the item's detail page underneath its image. Markdown syntax is supported.</p>

                            <textarea
                                name="" id="" placeholder='e. g. "After purchasing you’ll be able to get the real T-Shirt"'
                                cols={30} rows={4}
                                className="w-full h-full  text-cusBlack dark:text-white
                                    outline-none lightBlueBg p-4 sm:p-6 rounded-xl mt-3 form-input"  />

                        </div>





                        <div className="mt-8">

                            <div className="flex justify-start items-center">
                                <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Collection</h4>
                                <NavLink to="/createNewCollection" className="ml-2.5">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 sm:h-5 sm:w-5 blackWhiteSVG3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
                                    </svg>
                                </NavLink>
                            </div>


                            <div className="flex xsm:flex-row flex-col justify-between items-center">

                                <div className="flex justify-start items-center xsm:mr-5">
                                    <p className="xs:text-xs sm:text-sm text-cusBlack dark:text-cusBlueWhite mr-3">This is the collection where your item will appear.</p>
                                    <div>
                                        <div className="w-6 h-6 flex justify-center items-center rounded-full lightBlueBg">
                                            <svg xmlns="http://www.w3.org/2000/svg" width={5} height={17} viewBox="0 0 5 17">
                                                <text id="Watch_the_Season_Fin" data-name="Watch the Season Fin" transform="translate(0 14)" fill="#656391" fontSize={16} fontFamily="TimesNewRomanPS-BoldItalicMT, Times New Roman" fontWeight={700} fontStyle="italic"><tspan x={0} y={0}>i</tspan></text>
                                            </svg>
                                        </div>
                                    </div>
                                </div>

                                <div className="lightBlueBg xsm:mt-0 mt-2 rounded-lg relative flex items-center lavels_radios_box w-full xsm:w-fit">
                                    <input type="radio" name="collectionRadios" id="single_collection" className="lavelsRadios" />
                                    <label htmlFor="single_collection" className="border-r border-[#00000030] dark:border-[#ffffff30] text-cusBlack dark:text-[#656391] w-full px-5 py-2.5 text-center cursor-pointer rounded-l-lg">Single</label>
                                    <input type="radio" name="collectionRadios" id="multiple_collection" className="lavelsRadios" />
                                    <label htmlFor="multiple_collection" className="text-cusBlack dark:text-[#656391] w-full px-5 py-2.5 text-center cursor-pointer rounded-r-lg">Multiple</label>
                                </div>
                            </div>






                            <div
                                ref={collectionSelectRef}
                                onClick={() => setColleSelectOpen(!colleSelectOpen)}
                                className="lightBlueBg p-5 rounded-xl mt-2 relative cursor-pointer" style={{ zIndex: 4 }}>
                                <div className="flex justify-between items-center relative">
                                    {collectionSelectedData
                                        ? <div className="flex justify-start items-center">
                                            <div className="w-6 h-6 rounded-full overflow-hidden">
                                                <img src={collectionSelectedData.collectionLogo} alt="" className="w-full h-full" />
                                            </div>
                                            <p className="text-l-LightBlack dark:text-white text-sm font-semibold ml-2">{collectionSelectedData.collectionName}</p>
                                        </div>
                                        : <p className="text-cusBlack dark:text-white font-semibold dark:font-medium text-xs  break-all sm:text-sm">Select a Collection</p>
                                    }

                                    <svg xmlns="http://www.w3.org/2000/svg" className={`${colleSelectOpen ? 'rotate-180' : ''} transition-all h-3.5 w-3.5 sm:h-5 sm:w-5 blackWhiteSVG3`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>
                                <AnimatePresence>
                                    {colleSelectOpen &&
                                        <motion.div
                                            animate={colleSelectOpen ? "open" : "closed"}
                                            variants={{
                                                open: { opacity: 1, y: 4 },
                                                closed: { opacity: 0, y: -10, },
                                            }}
                                            exit={{ opacity: 0, y: -10, }}
                                            transition={{ duration: 0.3 }}

                                            className="absolute right-0 top-14 w-full bg-white shadow-xl dark:bg-[#363375] rounded">

                                            {collectionsData.map(colle =>
                                                <button
                                                    className="w-full py-1.5 hover:bg-gray-200 hover:dark:bg-[#3c379d] px-3 flex justify-start items-center"
                                                    onClick={() => setCollectionSelectedData(colle)}
                                                    key={colle.id}
                                                >
                                                    <div className="w-7 h-7 rounded-full overflow-hidden">
                                                        <img src={colle.collectionLogo} alt="" className="w-full h-full" />
                                                    </div>

                                                    <p className="text-l-LightBlack dark:text-white text-sm font-semibold ml-2">{colle.collectionName}</p>
                                                </button>
                                            )}
                                        </motion.div>}
                                </AnimatePresence>
                            </div>

                        </div>






                        <div className="mt-8">
                            <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Properties</h4>
                            <p className="xs:text-xxs mt-2 sm:text-sm text-cusBlack dark:text-cusBlueWhite">Textual traits that show up as rectangles</p>
                            <div className="grid xs:grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 items-center">
                                <input type="text" name="" id="" placeholder='e. g. "size"'
                                    className="
                                        lightBlueBg p-4 sm:p-5 rounded-xl mt-3 form-input transition-all duration-300
                                        bg-transparent w-full  outline-none text-cusBlack dark:text-white" />
                                <input type="text" name="" id="" placeholder='e. g. "M"'
                                    className="
                                        lightBlueBg p-4 sm:p-5 rounded-xl mt-3 form-input transition-all duration-300
                                        bg-transparent w-full outline-none text-cusBlack dark:text-white" />
                            </div>
                        </div>


                        <div className="add_more_btn_box mt-6">
                            <button className="lightBlueBg py-3 w-full rounded-lg add_more_btn text-cusBlack dark:text-white">
                                + Add more Properties
                            </button>
                        </div>



                        <div className="mt-8">
                            <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Levels</h4>
                            <p className="xs:text-xxs mt-2 sm:text-sm text-cusBlack dark:text-cusBlueWhite">Numerical traits that show as a progress bar</p>
                            <div className="grid xs:grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 items-center">

                                <input type="text" name="" id="" placeholder='e. g. "size"'
                                    className="
                                        lightBlueBg p-4 sm:p-5 rounded-xl mt-3 relative form-input transition-all duration-300
                                        bg-transparent w-full outline-none text-cusBlack dark:text-white" />

                                <div className="lightBlueBg rounded-xl mt-3 relative flex items-center lavels_radios_box">
                                    <input type="radio" name="lavelsRadios" id="lavels01" className="lavelsRadios" />
                                    <label htmlFor="lavels01" className="border-r border-[#00000030] dark:border-[#ffffff30] text-cusBlack dark:text-[#656391] w-full py-5 text-center cursor-pointer rounded-l-xl">01</label>
                                    <input type="radio" name="lavelsRadios" id="lavelsOf" className="lavelsRadios" />
                                    <label htmlFor="lavelsOf" className="border-r border-[#00000030] dark:border-[#ffffff30] text-cusBlack dark:text-[#656391] w-full py-5 text-center cursor-pointer">Of</label>
                                    <input type="radio" name="lavelsRadios" id="lavels05" className="lavelsRadios" />
                                    <label htmlFor="lavels05" className="text-cusBlack dark:text-[#656391] w-full py-5 text-center cursor-pointer rounded-r-xl">05</label>
                                </div>
                            </div>
                        </div>


                        <div className="add_more_btn_box mt-6">
                            <button className="lightBlueBg py-3 w-full rounded-lg add_more_btn text-cusBlack dark:text-white">
                                + Add more Levels
                            </button>
                        </div>



                        <div className="mt-8">
                            <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Stats</h4>
                            <p className="xs:text-xxs mt-2 sm:text-sm text-cusBlack dark:text-cusBlueWhite">Numerical traits that just show as numbers</p>
                            <div className="grid xs:grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 items-center">

                                <input type="text" name="" id="" placeholder='e. g. "size"'
                                    className="
                                        lightBlueBg p-4 sm:p-5 rounded-xl mt-3 relative form-input transition-all duration-300
                                        bg-transparent w-full outline-none text-cusBlack dark:text-white" />

                                <div className="lightBlueBg rounded-xl mt-3 relative flex items-center lavels_radios_box">
                                    <input type="radio" name="statsRadios" id="stats01" className="lavelsRadios" />
                                    <label htmlFor="stats01" className="border-r border-[#00000030] dark:border-[#ffffff30] text-cusBlack dark:text-[#656391] w-full py-5 text-center cursor-pointer rounded-l-xl">01</label>
                                    <input type="radio" name="statsRadios" id="statsOf" className="lavelsRadios" />
                                    <label htmlFor="statsOf" className="border-r border-[#00000030] dark:border-[#ffffff30] text-cusBlack dark:text-[#656391] w-full py-5 text-center cursor-pointer">Of</label>
                                    <input type="radio" name="statsRadios" id="stats05" className="lavelsRadios" />
                                    <label htmlFor="stats05" className="text-cusBlack dark:text-[#656391] w-full py-5 text-center cursor-pointer rounded-r-xl">05</label>
                                </div>
                            </div>
                        </div>


                        <div className="add_more_btn_box mt-6">
                            <button className="lightBlueBg py-3 w-full rounded-lg add_more_btn text-cusBlack dark:text-white">
                                + Add more Stats
                            </button>
                        </div>


                        <div className="mt-8">
                            <div className="flex justify-between items-center">
                                <div>
                                    <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-lg">Unlock once purchased</h4>
                                    <p className="text-sm text-cusBlack dark:text-cusBlueWhite">Content will be unlocked after successful transaction</p>
                                </div>

                                <div className="flex items-center justify-center">
                                    <label htmlFor="unlockOncePurchesed" className="flex items-center cursor-pointer">
                                        <div className="relative">
                                            <input type="checkbox" id="unlockOncePurchesed" name="postOnActivity" className="sr-only" />
                                            <div className="block w-16 h-8 rounded-full toogle_btn_bg" />
                                            <div className="dot absolute left-1.5 top-1 w-6 h-6 rounded-full transition" />
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>


                        <div className="mt-8">
                            <div className="flex justify-between items-center">
                                <div>
                                    <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-lg">Explicit & Sensitive Content</h4>
                                    <div className="flex justify-start items-center">
                                        <p className="xs:text-xs sm:text-sm text-cusBlack dark:text-cusBlueWhite mr-3">Set this item as explicit and sensitive content</p>
                                        <div className="w-6 h-6 flex justify-center items-center rounded-full lightBlueBg">
                                            <svg xmlns="http://www.w3.org/2000/svg" width={5} height={17} viewBox="0 0 5 17">
                                                <text id="Watch_the_Season_Fin" data-name="Watch the Season Fin" transform="translate(0 14)" fill="#656391" fontSize={16} fontFamily="TimesNewRomanPS-BoldItalicMT, Times New Roman" fontWeight={700} fontStyle="italic"><tspan x={0} y={0}>i</tspan></text>
                                            </svg>

                                        </div>
                                    </div>
                                </div>

                                <div className="flex items-center justify-center">
                                    <label htmlFor="explicitContent" className="flex items-center cursor-pointer">
                                        <div className="relative">
                                            <input type="checkbox" id="explicitContent" name="postOnActivity" className="sr-only" />
                                            <div className="block w-16 h-8 rounded-full toogle_btn_bg" />
                                            <div className="dot absolute left-1.5 top-1 w-6 h-6 rounded-full transition" />
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="mt-8">
                            <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Supply</h4>
                            <div className="flex justify-start items-center">
                                <p className="xs:text-xs sm:text-sm text-cusBlack dark:text-cusBlueWhite mr-3">The number of items that can be minted. No gas cost to you! </p>
                                <div className="w-6 h-6 flex justify-center items-center rounded-full lightBlueBg">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={5} height={17} viewBox="0 0 5 17">
                                        <text id="Watch_the_Season_Fin" data-name="Watch the Season Fin" transform="translate(0 14)" fill="#656391" fontSize={16} fontFamily="TimesNewRomanPS-BoldItalicMT, Times New Roman" fontWeight={700} fontStyle="italic"><tspan x={0} y={0}>i</tspan></text>
                                    </svg>

                                </div>
                            </div>

                            <input type="text" name="" id="" placeholder='' defaultValue="1"
                                className="
                                    lightBlueBg p-4 sm:p-5 rounded-xl mt-3 relative form-input transition-all duration-300
                                    bg-transparent w-full outline-none text-cusBlack dark:text-white" />

                        </div>


                        <div className="mt-8">
                            <div className="flex justify-start items-center">
                                <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Freeze metadata </h4>
                                <div className="w-6 h-6 flex justify-center items-center rounded-full lightBlueBg">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={5} height={17} viewBox="0 0 5 17">
                                        <text id="Watch_the_Season_Fin" data-name="Watch the Season Fin" transform="translate(0 14)" fill="#656391" fontSize={16} fontFamily="TimesNewRomanPS-BoldItalicMT, Times New Roman" fontWeight={700} fontStyle="italic"><tspan x={0} y={0}>i</tspan></text>
                                    </svg>
                                </div>
                            </div>
                            <p className="xs:text-xs sm:text-sm text-cusBlack dark:text-cusBlueWhite">Freezing your metadata will allow you to permanently lock and store all of this item's content in decentralized file storage.</p>

                            <input type="text" name="" id="" placeholder='To freeze your metadata, you must create your item first.'
                                className="
                                    lightBlueBg p-4 sm:p-5 rounded-xl mt-3 relative form-input transition-all duration-300
                                    bg-transparent w-full outline-none text-cusBlack dark:text-white" />

                        </div>



                        <div className="mt-6">
                            <h5 className="text-cusBlack dark:text-white font-semibold text-sm sm:text-base md:text-lg lgtext-xl">Sale Type</h5>

                            <div
                                ref={saleTypeRef}
                                onClick={() => setSaleTypeDropOpen(!saleTypeDropOpen)}
                                className="relative">
                                <div className=" flex justify-between items-center relative lightBlueBg p-5 rounded-xl mt-2 cursor-pointer" style={{ zIndex: 0 }}>
                                    <p className="text-cusBlack dark:text-white font-semibold dark:font-medium text-xs  break-all sm:text-sm">{saleTypeDropText}</p>

                                    <svg xmlns="http://www.w3.org/2000/svg" className={`${saleTypeDropOpen ? 'rotate-180' : ''} transition-all h-3.5 w-3.5 sm:h-5 sm:w-5 blackWhiteSVG3`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>
                                <AnimatePresence>
                                    {saleTypeDropOpen &&
                                        <motion.div
                                            animate={saleTypeDropOpen ? "open" : "closed"}
                                            variants={{
                                                open: { opacity: 1, y: 4 },
                                                closed: { opacity: 0, y: -10, },
                                            }}
                                            exit={{ opacity: 0 }}
                                            transition={{ duration: 0.3 }}
                                            className="absolute right-0 top-14 w-full bg-white shadow-xl dark:bg-[#363375] rounded " style={{ zIndex: 3 }}>

                                            {["Sell", "Auction", "Stake",].map(level =>
                                                <button
                                                    className="w-full py-3 hover:bg-gray-200 hover:dark:bg-[#3c379d] px-3 flex justify-start items-center transition-all"
                                                    onClick={() => setSaleTypeDropText(level)}
                                                    key={level}
                                                >
                                                    <p className="text-l-LightBlack dark:text-white text-sm font-semibold ml-2">{level}</p>
                                                </button>
                                            )}

                                        </motion.div>}
                                </AnimatePresence>
                            </div>
                        </div>


                        <div className="mt-8">
                            <div className="flex justify-between items-center">
                                <div>
                                    <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-lg">Post on Activity</h4>
                                    <p className="text-sm text-cusBlack dark:text-cusBlueWhite">Add this NFTs to your post activity</p>
                                </div>

                                <div className="flex items-center justify-center">
                                    <label htmlFor="postOnActivityBtn" className="flex items-center cursor-pointer">
                                        <div className="relative">
                                            <input type="checkbox" id="postOnActivityBtn" name="postOnActivity" className="sr-only" />
                                            <div className="block w-16 h-8 rounded-full toogle_btn_bg" />
                                            <div className="dot absolute left-1.5 top-1 w-6 h-6 rounded-full transition" />
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <input type="text" name="" id="" placeholder='Add your post comments'
                            className="bg-transparent w-full outline-none text-cusBlack dark:text-white
                            lightBlueBg p-4 sm:p-5 rounded-xl mt-6 relative form-input transition-all duration-300" />



                        <button className="xs:text-sm md:text-lg font-semibold text-white mt-5 xs:p-4 sm:p-6 xl:p-7 2xl:p-8 w-full rounded-xl  gradientBtn">
                            Create Item
                        </button>
                    </div>




                    <Previews />





                </div>
            </form>
        </div >
    );
}
